import { createSelector } from 'reselect';

const selectRaw = (state) => state.recurso.destroy;

const selectLoading = createSelector([selectRaw], (raw) =>
  Boolean(raw.loading),
);

const recursoDestroySelectors = {
  selectLoading,
};

export default recursoDestroySelectors;
